import { render, staticRenderFns } from "./NewGroupType.vue?vue&type=template&id=c4d0a6c8&"
import script from "./NewGroupType.vue?vue&type=script&lang=js&"
export * from "./NewGroupType.vue?vue&type=script&lang=js&"
import style0 from "./NewGroupType.vue?vue&type=style&index=0&id=c4d0a6c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports